import sliceCreator from '../../index.js';
import {RAWMATERIAL_MACHINE_MAPPING} from '../../../constants/index.js';
const _rawMaterialMachineMappingAction = sliceCreator('RAWMATERIAL_MACHINE_MAPPING', RAWMATERIAL_MACHINE_MAPPING, 'post');

const { asyncAction: rawMaterialMachineMappingAction, reducer, clearData: clearRawMaterialMachineMappingAction } = _rawMaterialMachineMappingAction;

export default reducer;

export {
    rawMaterialMachineMappingAction,
    clearRawMaterialMachineMappingAction
}